
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({  name: 'sortBy' })
export class SortByPipe implements PipeTransform {

  transform(records: Array<any>, args?: any): any {
    return records.sort(function(a, b){
          if(a[args.property].toLowerCase() < b[args.property].toLowerCase()){
            return -1 * args.direction;
          }
          else if( a[args.property].toLowerCase() > b[args.property].toLowerCase()){
            return 1 * args.direction;
          }
          else{
            return 0;
          }
        });
    };
}


// WEBPACK FOOTER //
// ./src/app/shared/_pipes/sortBy.pipe.ts